// @tennis-matches/services/governance — Excel/CSV Parser für Vereinsimport

function __asStr(v) {
  return String(v ?? "").trim();
}

async function __loadXlsx() {
  try {
    return await import("https://esm.sh/xlsx@0.18.5");
  } catch (e) {
    throw new Error(`XLSX Import fehlgeschlagen (Netzwerk?): ${String(e?.message || e)}`);
  }
}

function __parseCsvLine(line, delimiter = ";") {
  const out = [];
  let cur = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      if (inQuotes && line[i + 1] === '"') {
        cur += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }
    if (!inQuotes && ch === delimiter) {
      out.push(cur);
      cur = "";
      continue;
    }
    cur += ch;
  }
  out.push(cur);
  return out.map((c) => c.trim());
}

function __parseCsvText(text) {
  const raw = String(text || "").replace(/^\uFEFF/, "");
  const lines = raw.split(/\r?\n/).filter((l) => l.trim().length > 0);
  if (!lines.length) return [];
  const delimiter = lines[0].includes(";") ? ";" : ",";
  return lines.map((line) => __parseCsvLine(line, delimiter));
}

/**
 * @param {File} file
 * @returns {Promise<{ sheetName: string, headers: string[], rowsAoA: string[][] }>}
 */
export async function parseClubImportSpreadsheet(file) {
  if (!file) throw new Error("missing-file");
  const name = __asStr(file.name).toLowerCase();

  if (name.endsWith(".csv")) {
    const text = await file.text();
    const rowsAoA = __parseCsvText(text);
    const headers = (rowsAoA[0] || []).map((h) => __asStr(h));
    return { sheetName: "CSV", headers, rowsAoA };
  }

  if (name.endsWith(".xlsx") || name.endsWith(".xls")) {
    const XLSX = await __loadXlsx();
    const buf = await file.arrayBuffer();
    const wb = XLSX.read(buf, { type: "array" });
    const sheetName = wb.SheetNames?.[0] || "";
    if (!sheetName) return { sheetName: "", headers: [], rowsAoA: [] };
    const ws = wb.Sheets[sheetName];
    const rowsAoA = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, defval: "" });
    const normalized = (Array.isArray(rowsAoA) ? rowsAoA : []).map((row) =>
      (Array.isArray(row) ? row : []).map((cell) => __asStr(cell))
    );
    const headers = (normalized[0] || []).map((h) => __asStr(h));
    return { sheetName, headers, rowsAoA: normalized };
  }

  throw new Error("unsupported-format");
}
